import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Nav/Navbar";
import HomePage from "./Page/HomePage";
import ContactPage from "./Page/ContactPage";
import WebDev from "./Page/service/WebDev";
import EcommerceSolution from './Page/service/EcommerceSolution';
import VideoMarketing from './Page/service/VideoMarketing';
import PrivacyPolicy from "./Page/PrivacyPolicy.jsx";
import AboutUs from "./Page/AboutUs.jsx";

function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col w-full bg-gradient-to-r from-[#121212] to-[#10204d] overflow-x-hidden">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Direct routes for services */}
          <Route path="/services/webdevelopment" element={<WebDev />} />
          <Route path="/services/ecommercesolutions" element={<EcommerceSolution />} />
          <Route path="/services/videomarketing" element={<VideoMarketing />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/aboutus" element={<AboutUs />} />

          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />

        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
